import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { CurrencyHelper } from "~/helpers/currency_helper"
// This controller accepts events from the other Stimulus controllers to update the companies selection.

export default class extends Controller {
  static get values() {
    return {
      companyListId: { type: String, default: "" },
      selectedCompanyIds: { type: Array, default: [] },
      allSelected: { type: Boolean, default: false },
      exportLimit: Number,
      totalCount: Number,
      planName: String
    }
  }

  static targets = ["modalDeleteText"]

  submit(event) {
    this.performAction(event.target.value, "post")
  }

  destroy(event) {
    this.performAction(event.target.value, "delete")
  }

  export(event) {
    const selectedCount = this._getTotalCount()

    if (selectedCount > this.exportLimitValue) {
      const successMessage = i18n.t("js.back.company_actions.export.export_limit", { limit: this.exportLimitValue, plan_name: this.planNameValue })
      App.displayFlash("success", successMessage)
    }

    this.performAction(event.target.value, "post")
  }

  updateSelection(event) {
    if (event.detail) {
      this.allSelectedValue = event.detail.allSelected
      this.selectedCompanyIdsValue = event.detail.dataSets.map(dataSet => dataSet.companyId || dataSet.recordId).filter(Boolean)
      const numberOfCompanies = this.allSelectedValue === true ? this.totalCountValue : this.selectedCompanyIdsValue.length
      const companyName = numberOfCompanies === 1 ? event.detail.dataSets[0]?.companyName : false

      if (companyName) {
        this.modalDeleteTextTarget.innerHTML = i18n.t("js.back.company_actions.modal_delete_name_html", { company_name: companyName })
      } else {
        this.modalDeleteTextTarget.innerHTML = i18n.t("js.back.company_actions.modal_delete_html", { count: numberOfCompanies, number: CurrencyHelper.numberWithDelimiter(numberOfCompanies) })
      }
    }
  }

  performAction(url, method) {
    if (url) {
      TempFormHelper.create(url, method, (form) => {
        if (this.allSelectedValue) {
          TempFormHelper.addHiddenInput(form, "company_list_id", this.companyListIdValue)
        } else {
          this.selectedCompanyIdsValue.forEach(id => {
            TempFormHelper.addHiddenInput(form, "company_ids[]", id)
          })
        }
      }).submit()
    }
  }

  _getTotalCount() {
    if (this.allSelectedValue) {
      return this.totalCountValue
    }

    return this.selectedCompanyIdsValue.length
  }
}
